import React from "react";
import Accordion from "react-bootstrap/Accordion";
import Select from "react-select";

const Other = () => {
  const customerOptions = [
    { value: 1, label: "Rohit" },
    { value: 2, label: "Ravi" },
    { value: 3, label: "Sakshi" },
    { value: 4, label: "Abhishek" },
    { value: 5, label: "Shweta" },
  ];
  const organisationOptions = [
    { value: 1, label: "Organisation 1" },
    { value: 2, label: "Orgnaistaion 2" },
    { value: 3, label: "Orgnaistaion 3" },
    { value: 4, label: "Orgnaistaion 5" },
    { value: 5, label: "Orgnaistaion 4" },
  ];
  return (
    <>
      <form>
        <div className="row border-bottom-2 pb-3">
          <div className="col-md-12">
            <div className="card px-3 py-2">
              <div className="col-md-12">
                <div className="input_box_section">
                    <label htmlFor="" className="form-label  mb-0">
                  Single Freight,Insurance & other charges for all Invoices
                  </label>
                  <input
                      type="checkbox"
                      className="ms-2"
                    />
                </div>
              </div>
              <div className="row">
                <table className="table table-striped table-sm">
                  <thead>
                    <tr>
                      <th scope="col"></th>
                      <th scope="col">Currency</th>
                      <th scope="col">Exch. Rate</th>
                      <th scope="col">Rate</th>
                      <th scope="col">Amount</th>
                      <th scope="col"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="row">
                        <label className="mx-1" htmlFor="Freight">
                        Agency
                        </label>
                      </th>
                      <td>
                        <select className="form-control form-control-sm">
                          <option value="Self" selected>
                            -
                          </option>
                          <option value="Group Company">-</option>
                          <option value="Other">-</option>
                        </select>
                      </td>
                      <td>
                        <input type="text" className="form-control form-control-sm" />
                      </td>
                      <td>
                        <div className="d-flex">
                      <input type="text" className="form-control form-control-sm" />
                      <label>%</label>
                      </div>
                      </td>
                      <td>
                      <input type="text" className="form-control form-control-sm" />
                      </td>
                      <td>
                      
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">
                        <label className="mx-1" htmlFor="Freight">
                        Discount, if any
                        </label>
                      </th>
                      <td>
                      <input type="text" className="form-control form-control-sm" />
                      </td>
                      <td>
                        <input type="text" className="form-control form-control-sm" />
                      </td>
                      <td>
                        <div className="d-flex">
                      <input type="text" className="form-control form-control-sm" />
                      <label>%</label>
                      </div>
                      </td>
                      <td>
                      <input type="text" className="form-control form-control-sm" />
                      </td>
                      <td>
                      <input type="text" className="form-control form-control-sm" />
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">
                        <label className="mx-1" htmlFor="Freight">
                        Miscellaneous Chrgs.
                        </label>
                      </th>
                      <td>
                        <select className="form-control form-control-sm">
                          <option value="Self" selected>
                            -
                          </option>
                          <option value="Group Company">-</option>
                          <option value="Other">-</option>
                        </select>
                      </td>
                      <td>
                        <input type="text" className="form-control form-control-sm" />
                      </td>
                      <td>
                        <div className="d-flex">
                      <input type="text" className="form-control form-control-sm" />
                      <label>%</label>
                      </div>
                      </td>
                      <td>
                      <input type="text" className="form-control form-control-sm" />
                      </td>
                      <td>
                      <input type="text" className="form-control form-control-sm" />
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">
                        <label className="mx-1" htmlFor="Freight">
                        Loading
                        </label>
                      </th>
                      <td>
                        <select className="form-control form-control-sm">
                          <option value="Self" selected>
                            -
                          </option>
                          <option value="Group Company">-</option>
                          <option value="Other">-</option>
                        </select>
                      </td>
                      <td>
                        <input type="text" className="form-control form-control-sm" />
                      </td>
                      <td>
                        <div className="d-flex">
                      <input type="text" className="form-control form-control-sm" />
                      <label>%</label>
                      </div>
                      </td>
                      <td>
                      <input type="text" className="form-control form-control-sm" />
                      </td>
                      <td>
                       
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">
                        <label className="mx-1" htmlFor="Freight">
                        Freight
                        </label>
                      </th>
                      <td>
                        <select className="form-control form-control-sm">
                          <option value="Self" selected>
                            -
                          </option>
                          <option value="Group Company">-</option>
                          <option value="Other">-</option>
                        </select>
                      </td>
                      <td>
                        <input type="text" className="form-control form-control-sm" />
                      </td>
                      <td>
                        <div className="d-flex">
                      <input type="text" className="form-control form-control-sm" />
                      <label>%</label>
                      </div>
                      </td>
                      <td>
                      <input type="text" className="form-control form-control-sm" />
                      </td>
                      <td>
                       
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">
                        <label className="mx-1" htmlFor="Freight">
                        Insurance
                        </label>
                      </th>
                      <td>
                        <select className="form-control form-control-sm">
                          <option value="Self" selected>
                            -
                          </option>
                          <option value="Group Company">-</option>
                          <option value="Other">-</option>
                        </select>
                      </td>
                      <td>
                        <input type="text" className="form-control form-control-sm" />
                      </td>
                      <td>
                        <div className="d-flex">
                      <input type="text" className="form-control form-control-sm" />
                      <label>%</label>
                      </div>
                      </td>
                      <td>
                      <input type="text" className="form-control form-control-sm" />
                      </td>
                      <td>
                       
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">
                        <label className="mx-1" htmlFor="Freight">
                        Addl Chrg(High Sea)
                        </label>
                      </th>
                      <td>
                        <select className="form-control form-control-sm">
                          <option value="Self" selected>
                            -
                          </option>
                          <option value="Group Company">-</option>
                          <option value="Other">-</option>
                        </select>
                      </td>
                      <td>
                        <input type="text" className="form-control form-control-sm" />
                      </td>
                      <td>
                        <div className="d-flex">
                      <input type="text" className="form-control form-control-sm" />
                      <label>%</label>
                      </div>
                      </td>
                      <td>
                      <input type="text" className="form-control form-control-sm" />
                      </td>
                      <td>
                       
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">
                        <label className="mx-1" htmlFor="Freight">
                        Revenue Deposit
                        </label>
                      </th>
                      <td>
                      <div className="d-flex">
                      <input type="text" className="form-control form-control-sm" />
                      <label>%</label>
                      </div>
                      </td>
                      <td>
                      <div className="d-flex">
                      <label>on</label>
                      <input type="text" className="form-control form-control-sm" />
                      </div>
                      </td>
                      <td>
                        
                      </td>
                      <td>
                       
                      </td>
                      <td>
                       
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">
                        <label className="mx-1" htmlFor="Freight">
                        Landing Charge
                        </label>
                      </th>
                      <td>
                      <div className="d-flex">
                      <input type="text" className="form-control form-control-sm" />
                      <label>%</label>
                      </div>
                      </td>
                      <td>
                         
                      </td>
                      <td>
                         
                      </td>
                      <td>
                       
                      </td>
                      <td>
                       
                      </td>
                    </tr>
                    
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default Other;
